import { observable } from "mobx";
import { AuthenticationModel } from "../models/AuthenticationModel";
import { IMindMeAccountDetails } from "../interfaces";

class AuthService {
  public authData = new AuthenticationModel();
  @observable public isLoggedIn: boolean = this.authData.isLoggedIn;
  public fromPaymentSystem: boolean = false;
  public prefixRoute: string = "/app/";
  public mindmeAccountDetails: IMindMeAccountDetails | null = null;
  public hideLeftMenuFlag: boolean = false;
  public hideHeaderBarFlag: boolean = false;
  public lastRoute: string = "";
  public mindMeRoute: string = "";

  setMindMeRoute(value: string) {
    this.mindMeRoute = value;
  }

  setLastRoute(value: string) {
    this.lastRoute = value;
  }

  setLoginState(value: boolean) {
    this.isLoggedIn = value;
  }

  setAuthData(accountId: string) {
    this.authData.accountId = accountId;
    this.setLoginState(true);
  }

  setLogOutState() {
    this.setLoginState(false);
    this.authData.removeAuthData();
  }

  setFromPaymentSystem(value: boolean) {
    this.fromPaymentSystem = value;
    if (!this.authData.accountId && this.fromPaymentSystem) {
      this.setAuthData(`${process.env.REACT_APP_TEST_ACCOUNT_ID}`);
    }
  }

  setPrefixRoute(value: string) {
    this.prefixRoute = value;
  }

  setMindmeAccountDetails(data: IMindMeAccountDetails) {
    this.mindmeAccountDetails = data;
  }

  setHideLeftMenu(value: boolean) {
    this.hideLeftMenuFlag = value;
  }

  get hasAccount(): boolean {
    return this.authData.accountId ? true : false;
  }

  get hideLeftMenu(): boolean {
    return this.hideLeftMenuFlag || !this.hasAccount;
  }

  setHideHeaderBar(value: boolean) {
    this.hideHeaderBarFlag = value;
  }

  get hideHeaderBar(): boolean {
    return this.hideHeaderBarFlag || !this.hasAccount;
  }

  get isMerchantAccountsRoute(): boolean {
    return window.location.pathname.includes(
      `${this.prefixRoute}merchant-accounts`
    );
  }

  get isMindMeContactRoute(): boolean {
    return this.mindMeRoute.includes(`${this.prefixRoute}find-account/contact`);
  }

  get getMindMeContactId(): string {
    if(!this.isMindMeContactRoute) {
      return "";  
    }
    const pathSegments = this.mindMeRoute.split("/");
    return pathSegments.length > 0 ? pathSegments[pathSegments.length - 1] : "";
  } 
}
export default new AuthService();
